import { getQueryParams } from "@/utils/httpRequest";
import { loanService } from "@/modules/loan/store/services/loan-service";

const getLoansKanban = loanService.injectEndpoints({
  endpoints: builder => ({
    getLoansKanban: builder.query({
      query: params => `loans/kanban?${getQueryParams(params)}`,
      providesTags: [{ type: "Loan", id: "KANBAN" }],
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoansKanbanQuery } = getLoansKanban;

